import { formatIsoLocalTimestamp } from './formatCamMatchDisplay';

/** `MMM yyyy` for cam match exemplar period, or empty when `localTimestamp` is invalid. */
export function formatCamMatchPeriod(localTimestamp: string): string {
  return formatIsoLocalTimestamp(localTimestamp, 'MMM yyyy');
}
